import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  year: number;
  month: number | null;
  quarter: number | null;
}

export const useGenerateIntrastatReport = () => {
  return useMutation({
    mutationFn: async ({ year, month, quarter }: HookProps) => {
      await request(
        {
          path: `declarations/generate-intrastat-report`,
          method: 'POST',
          authenticate: true,
          fileDownload: true,
          dataObject: {
            quarter,
            month,
            year,
          },
        },
        true,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
